export default __webpack_public_path__ + "static/media/portfolio.e3c2db2b.png";